import { APP_INITIALIZER, Provider } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { FUSE_MOCK_API_DEFAULT_DELAY } from '@fuse/lib/mock-api/mock-api.constants';
import { FuseMockApiInterceptor } from '@fuse/lib/mock-api/mock-api.interceptor';

export const provideFuseMockApi = (mockApiServices: any[], config?: { delay?: number }): Provider[] => {
    return [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: FuseMockApiInterceptor,
            multi: true
        },
        {
            provide: APP_INITIALIZER,
            deps: [...mockApiServices],
            useFactory: () => (): any => null,
            multi: true
        },
        {
            provide: FUSE_MOCK_API_DEFAULT_DELAY,
            useValue: config?.delay ?? 0
        }
    ];
};
